import { useState } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import { debounce } from "lodash";
import { Program } from '../../../../../../Models/Program';
import './ProgramsSelection.css';

export default function Programs(props: { programs: Program[]; setSelectedPrograms: (arg0: Program[]) => void; }) {
  const [programs] = useState<Program[]>(props.programs);
  const [searchFilteredPrograms, setSearchFilteredPrograms] = useState<Program[]>(props.programs);
  const [selectedPrograms, setSelectedPrograms] = useState<Program[] | null>(null);

  const handleToggle = (program: Program) => () => {
    let newSelected = selectedPrograms ? [...selectedPrograms] : [];
    if (selectedPrograms?.includes(program)) {
      newSelected = newSelected.filter((p: Program) => p.id !== program.id);
    } else {
      newSelected.push(program);
    }

    setSelectedPrograms(newSelected);
    props.setSelectedPrograms(newSelected);
  };

  const handleSearch = debounce((event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value;
    const updatedList = programs.filter((p: Program) => {
      return p.id.toLowerCase().includes(query.toLowerCase()) || p.name.toLowerCase().includes(query.toLowerCase());
    });
    setSearchFilteredPrograms(updatedList);
  }, 200);

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedPrograms(programs);
      props.setSelectedPrograms(programs);
    }
    else {
      setSelectedPrograms([]);
      props.setSelectedPrograms([]);
    }
  }

  return (
    <>
      <div className="flex margin-b-20">
        <TextField name="search" label="Search" className="w-30" variant="standard" onChange={handleSearch} />
        <FormControlLabel control={
          <Checkbox
            checked={selectedPrograms ? selectedPrograms.length === programs.length : false}
            onChange={handleSelectAll}
          />
        } label="Select All" />
      </div>
      <List
        className="list"
        style={{ borderBottom: selectedPrograms?.length === 0 ? '2px solid #d32f2f' : '' }}
      >
        {searchFilteredPrograms.map((program: Program) => {
          const labelId = `checkbox-list-label-${program.id}`;

          return (
            <ListItem
              key={program.id}
              disablePadding
            >
              <ListItemButton onClick={handleToggle(program)} dense>
                <Checkbox
                  checked={selectedPrograms ? selectedPrograms.includes(program) : false}
                  inputProps={{ 'aria-labelledby': labelId }}
                />
                <ListItemText id={labelId} primary={`${program.id} - ${program.name}`} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <p>
        Programs selected: {selectedPrograms ? selectedPrograms.length : 0}
      </p>
    </>
  );
}